// Mirrors ipc-web-api/constants/attachments.js — keep in sync.

export const FILE_CATEGORIES = {
  OTHER: 0,
  MODEL: 1,
  SETUP: 2,
  VENDOR_QUOTE: 3,
  CUSTOMER_DRAWING: 4,
  PACKING_SLIP: 5,
  PURCHASE_ORDER: 6,
  VENDOR_PURCHASE_ORDER: 7,
  INVOICE: 8,
  CUSTOMER_SPEC: 9,
  QUOTE_PDF: 10,
};

// id + label + icon. Add an entry here to expose a new category in the UI.
export const FILE_CATEGORY_LABELS = [
  { id: FILE_CATEGORIES.MODEL, label: "Model", icon: "GitBranch" },
  { id: FILE_CATEGORIES.SETUP, label: "Setup", icon: "Settings" },
  { id: FILE_CATEGORIES.VENDOR_QUOTE, label: "Vendor Quote", icon: "DollarSign" },
  {
    id: FILE_CATEGORIES.CUSTOMER_DRAWING,
    label: "Customer Drawing",
    icon: "Edit",
  },
  { id: FILE_CATEGORIES.PACKING_SLIP, label: "Packing Slip", icon: "Package" },
  {
    id: FILE_CATEGORIES.PURCHASE_ORDER,
    label: "Purchase Order",
    icon: "FileText",
  },
  {
    id: FILE_CATEGORIES.VENDOR_PURCHASE_ORDER,
    label: "Vendor PO",
    icon: "FileText",
  },
  { id: FILE_CATEGORIES.INVOICE, label: "Invoice", icon: "DollarSign" },
  {
    id: FILE_CATEGORIES.CUSTOMER_SPEC,
    label: "Customer Spec",
    icon: "FileText",
  },
  { id: FILE_CATEGORIES.QUOTE_PDF, label: "Quote PDF", icon: "FileText" },
  { id: FILE_CATEGORIES.OTHER, label: "Other", icon: "File" },
];

export const getCategoryLabel = (id) =>
  FILE_CATEGORY_LABELS.find((c) => c.id === id) || FILE_CATEGORY_LABELS.at(-1);

export const RESOURCE_TYPES = {
  QUOTE: "quote",
  LEAD: "lead",
  ORDER: "order",
  WORK_ORDER: "workOrder",
  PART: "part",
  CUSTOMER: "customer",
  SHIPMENT: "shipment",
  VENDOR_PO: "vendorPo",
  INVOICE: "invoice",
};

export const CATEGORY_REQUIREMENTS = {
  [FILE_CATEGORIES.MODEL]: ["customerId", "partId"],
  [FILE_CATEGORIES.SETUP]: ["customerId", "partId"],
  [FILE_CATEGORIES.CUSTOMER_DRAWING]: ["customerId", "partId"],
  [FILE_CATEGORIES.VENDOR_QUOTE]: ["vendorId", "stationId", "price"],
  [FILE_CATEGORIES.VENDOR_PURCHASE_ORDER]: [
    "customerId",
    "vendorId",
    "stationId",
    "price",
  ],
};

export const getCategoryRequirements = (category) =>
  CATEGORY_REQUIREMENTS[category] || [];

export const META_FIELD_LABELS = {
  customerId: "Customer",
  partId: "Part",
  vendorId: "Vendor",
  stationId: "Station / Service",
  price: "Price",
};
